var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2065,
    height: 2500,
    viewBox: "0 0 256 310",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.624 53.686L0 64v181.02l20.624 10.254.124-.149V53.828l-.124-.142",
    fill: "#8C3123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131 229L20.624 255.274V53.686L131 79.387V229",
    fill: "#E05243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.178 187.866l46.818 5.96.294-.678.263-76.77-.557-.6-46.818 5.874v66.214",
    fill: "#8C3123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 229.295l107.371 26.035.169-.269-.003-201.195-.17-.18-107.367 25.996v149.613",
    fill: "#8C3123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.827 187.866l-46.831 5.96v-78.048l46.831 5.874v66.214",
    fill: "#E05243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.827 89.631l-46.831 8.535-46.818-8.535 46.759-12.256 46.89 12.256",
    fill: "#5E1F18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.827 219.801l-46.831-8.591-46.818 8.591 46.761 13.053 46.888-13.053",
    fill: "#F2B0A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.178 89.631l46.818-11.586.379-.117V.313L127.996 0 81.178 23.413v66.218",
    fill: "#8C3123"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.827 89.631l-46.831-11.586V0l46.831 23.413v66.218",
    fill: "#E05243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 309.428l-46.823-23.405v-66.217l46.823 11.582.689.783-.187 75.906-.502 1.351",
    fill: "#8C3123"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 309.428l46.827-23.405v-66.217l-46.827 11.582v78.04M235.367 53.686L256 64v181.02l-20.633 10.31V53.686",
    fill: "#E05243"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.b65fb60a8861f2a2025d26d105e08624.svg";
export { ForwardRef as ReactComponent };